import Appsignal from '@appsignal/javascript';
import { plugin as pluginPathDecorator } from '@appsignal/plugin-path-decorator';
import { plugin as pluginWindowEvents } from '@appsignal/plugin-window-events';
import { plugin as pluginCsp } from './appsignal/plugin-csp';

const appsignal = new Appsignal({
  key: document.querySelector('meta[name="appsignal-frontend-api-key"]').content,
  revision: document.querySelector('meta[name="appsignal-revision"]').content,
});

appsignal.use(pluginPathDecorator());
appsignal.use(pluginWindowEvents());

if (document.querySelector('html').dataset.cspEnabled === 'true') {
  appsignal.use(pluginCsp(document));
}

export default appsignal;
